module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiAxNjBjMTMxLjIgMCAyMzkuNCA5OC44IDI1NC4zIDIyNmEyMjQgMjI0IDAgMCAxLTIyLjYgNDQ1LjlMNzM2IDgzMmgtMTYwdi0xNDYuOGg3OC40YTE2IDE2IDAgMCAwIDEzLjItMjUuMWwtMS45LTIuMi0xMzEuMS0xMzEuMWEzMiAzMiAwIDAgMC00Mi4yLTIuN2wtMyAyLjctMTMxLjEgMTMxLjFhMTYgMTYgMCAwIDAgOC40IDI3bDIuOSAwLjNINDQ4VjgzMkgyODhhMjI0IDIyNCAwIDAgMS0zMC4yLTQ0NkEyNTYgMjU2IDAgMCAxIDUxMiAxNjB6IiBmaWxsPSIjMCIgcC1pZD0iNDM0OSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Cloud upload-filled.svg
// module id = D/Ig
// module chunks = 74